import doc                  from '@widesk-core/decorators/doc';
import model                from '@widesk-core/decorators/model';
import AccountServiceModel  from '@/models/AccountServiceModel';
import TimestampAble        from '@widesk-core/models/traits/TimestampAble';
import Blamable             from '@/models/traits/Blamable';
import SubscriptionModel    from '@/models/services/account/SubscriptionModel';
import FunctionalityModel   from '@/models/services/account/FunctionalityModel';

@model.urnResource('subscription_functionality')
@doc.path('/subscription_functionalities/{?id}')
export default class SubscriptionFunctionalityModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'subscription.id': id;
		'functionality.id': id;
	};

	private declare _tsSorts: {
		'id': string;
		'subscription.id': string;
		'functionality.id': string;
	};	

	@doc.model(SubscriptionModel) declare subscription: SubscriptionModel;
	@doc.model(FunctionalityModel) declare functionality: FunctionalityModel;
	@doc.string declare value: string;
}